import * as actionTypes from "./actionTypes";
import * as types from "./types";

// POST Spoke

export const postSpokeRequest = (
  payload: types.ISpokePostReq
): types.PostSpokeRequest => ({
  type: actionTypes.POST_SPOKE_REQUEST,
  payload,
});

export const postSpokeSuccess = (
  payload: types.IPostSpokeSuccessPayload
): types.PostSpokeSuccess => ({
  type: actionTypes.POST_SPOKE_SUCCESS,
  payload,
});

export const postSpokeFailure = (
  payload: types.IPostSpokeFailurePayload
): types.PostSpokeFailure => ({
  type: actionTypes.POST_SPOKE_FAILURE,
  payload,
});

//Get all Spokes
export const fetchSpokesRequest = (
  params: types.ISpokeSearchParams
): types.FetchSpokesReq => ({
  type: actionTypes.FETCH_SPOKE_LIST_REQUEST,
  params: params,
});

export const fetchSpokesSuccess = (
  payload: types.FetchSpokeSuccessPayload
): types.FetchSpokesSuccess => ({
  type: actionTypes.FETCH_SPOKE_LIST_SUCCESS,
  payload,
});

export const fetchSpokesFailure = (
  payload: types.FetchSpokeFailurePayload
): types.FetchSpokesFailure => ({
  type: actionTypes.FETCH_SPOKE_LIST_FAILURE,
  payload,
});

//Get Spokes By Id
export const fetchSpokeByIdRequest = (
  params: string
): types.FetchSpokesByIdReq => ({
  type: actionTypes.FETCH_SPOKE_BY_ID_REQUEST,
  params,
});

export const fetchSpokebyIdSuccess = (
  payload: types.FetchSpokeByIdSuccessPayload
): types.FetchSpokesByIdSuccess => ({
  type: actionTypes.FETCH_SPOKE_BY_ID_SUCCESS,
  payload,
});

export const fetchSpokeByIdFailure = (
  payload: types.FetchSpokeFailurePayload
): types.FetchSpokesByIdFailure => ({
  type: actionTypes.FETCH_SPOKE_BY_ID_FAILURE,
  payload,
});

// DELETE spoke

export const deleteSpokeReq = (
  params: number
): types.DeleteSpokeRequest => ({
  type: actionTypes.DELETE_SPOKE_REQUEST,
  params,
});

export const deleteSpokeSuccess = (
  success: types.IDeleteSpokeSuccess
): types.DeleteSpokeSuccess => ({
  type: actionTypes.DELETE_SPOKE_SUCCESS,
  success,
});

export const deleteSpokeFailure = (
  payload: types.IDeleteSpokeFailurePayload
): types.DeleteSpokeFailure => ({
  type: actionTypes.DELETE_SPOKE_FAILURE,
  payload,
});

//Get Spokes List on page load
export const fetchSpokesListRequest = (
  params: types.ISpokeSearchListParams
): types.FetchSpokesListReq => ({
  type: actionTypes.FETCH_SPOKE_LIST_LOAD_REQUEST,
  params: params,
});

export const fetchSpokesListSuccess = (
  payload: types.FetchSpokeListSuccessPayload
): types.FetchSpokesListSuccess => ({
  type: actionTypes.FETCH_SPOKE_LIST_LOAD_SUCCESS,
  payload,
});

export const fetchSpokesListFailure = (
  payload: types.FetchSpokeListFailurePayload
): types.FetchSpokesListFailure => ({
  type: actionTypes.FETCH_SPOKE_LIST_LOAD_FAILURE,
  payload,
});
